
import SharedLayout from './SharedLayout.vue';
import ScrollTracker from '@/components/shared/ScrollTracker';

export default {
  name: 'DefaultLayout',
  components: {
    ScrollTracker,
    SharedLayout,
  },
};
